import { api } from '@/core/api/';

const URL = 'api/providers/extendedacademicyear';
const header = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

export const getInitFilters = () => api.get(`${URL}/initfilters`);

export const search = (payload) =>
  api.get(`${URL}/search`, {
    params: {
      ...payload,
    },
  });

export const getRequestExtendedAcademicYear = (contractId) =>
  api.get(`${URL}/request/${contractId}`);

export const getRequestDocumentsByRequestId = (academicYearId, requestId) =>
  api.get(`${URL}/documents/${academicYearId}`, {
    params: {
      requestId,
    },
  });

export const getStatusLogByRequestId = (requestId) =>
  api.get(`${URL}/statuslog/${requestId}`);

export const changeRequestStatus = (payload) =>
  api.put(`${URL}/request`, payload);

export const getDocuments = (academicYearId, contractId) => {
  return api.get(`${URL}/documents/${academicYearId}?contractId=${contractId}`);
};

export const saveRequest = (payload) => {
  return api.post(`${URL}/request/`, payload, header);
};

export const validateRequest = (contractId) => {
  return api.get(`${URL}/validate/${contractId}`);
};

export const returnToPreviousStatus = (payload) =>
  api.post(`${URL}/returnToPreviousStatus`, payload);

export const getPreviousStatus = (requestId) =>
  api.get(`${URL}/statusToReturn?requestCompensatoryId=${requestId}`);
